/**
 * A wall-clock wait, for the shell's wall-clock plumbing only (the boot's retry, the round provider's pause before a
 * request still in progress goes again (decision 80), the early branding, the branding service's backoff, the sim
 * providers' simulated latency): eslint.config.js rejects the import in any other shell file and the shell's entry
 * does not export it. Presentation timing runs on the task runner (engine time), never here.
 */
export function wallClockSleep(ms: number): Promise<void> {
  return new Promise<void>((resolve) => setTimeout(resolve, Math.max(0, ms | 0)));
}
